import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/w/product-types')({
  staticData: { breadcrumb: 'Product Types', breadcrumbKey: 'K_LABEL_PRODUCT_TYPES' },
  component: ProductTypesLayout,
});

function ProductTypesLayout() {
  return <Outlet />;
}
